import { render, staticRenderFns } from "./PortalFeatures.vue?vue&type=template&id=3e45fc56&scoped=true&"
import script from "./PortalFeatures.vue?vue&type=script&lang=js&"
export * from "./PortalFeatures.vue?vue&type=script&lang=js&"
import style0 from "./PortalFeatures.vue?vue&type=style&index=0&id=3e45fc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e45fc56",
  null
  
)

export default component.exports